// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__33wtl","calendarButtons":"ClockData_calendarButtons__3gmId"};